/**
 * Returns today's date as "YYYY-MM-DD" in LOCAL timezone.
 * Never use new Date().toISOString().slice(0,10) for date comparisons —
 * toISOString() returns UTC and causes off-by-one errors for UTC+X timezones.
 */
export function localDateStr(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

// ── Brique unique de gestion des dates de naissance ─────────────────────────
// Source de vérité pour normaliser une date et calculer un âge, partagée par
// Contacts, ContactDetail, etc. (doctrine « un calcul = une brique »).
//
// Répare le bug historique des années à 2 chiffres mal enregistrées :
// « 01/10/74 » importé → « 0074-10-01 » (an 74) au lieu de « 1974-10-01 ».

/**
 * Normalise n'importe quelle date de naissance vers "YYYY-MM-DD" (ou null).
 * - accepte les datetime ISO ("1980-08-19T00:00:00Z" → "1980-08-19")
 * - répare les années < 100 par pivot de siècle (74 → 1974, 05 → 2005)
 * - rejette les valeurs implausibles / sentinelles « année inconnue » (≤ 1904)
 */
export function normalizeBirthDate(raw) {
  if (!raw) return null;
  const s = String(raw).trim().slice(0, 10);
  const m = s.match(/^(\d{1,4})-(\d{2})-(\d{2})$/);
  if (!m) return null;

  let y = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const d = parseInt(m[3], 10);
  if (!y || mo < 1 || mo > 12 || d < 1 || d > 31) return null;

  const nowY = new Date().getFullYear();
  // Année à 2 chiffres mal stockée → pivot de siècle (jamais dans le futur).
  if (y < 100) y = (y + 2000) <= nowY ? y + 2000 : y + 1900;

  // ≤ 1904 = sentinelle « année inconnue » (jour/mois seuls) ou valeur aberrante.
  if (y < 1905 || y > nowY) return null;

  return `${String(y).padStart(4, '0')}-${m[2]}-${m[3]}`;
}

/** Âge en années à partir d'une date de naissance (ou null si inconnue). */
export function contactAge(raw) {
  const s = normalizeBirthDate(raw);
  if (!s) return null;
  const [y, mo, d] = s.split('-').map(Number);
  const t = new Date();
  let age = t.getFullYear() - y;
  if (t.getMonth() + 1 < mo || (t.getMonth() + 1 === mo && t.getDate() < d)) age--;
  return age >= 0 && age <= 120 ? age : null;
}

/** Date de naissance formatée en français ("1 octobre 1974") ou null. */
export function formatBirthDateFr(raw) {
  const s = normalizeBirthDate(raw);
  if (!s) return null;
  const [y, mo, d] = s.split('-').map(Number);
  try {
    return new Date(y, mo - 1, d).toLocaleDateString('fr-CH', { day: 'numeric', month: 'long', year: 'numeric' });
  } catch { return s; }
}
